import intl from 'react-intl-universal';

import { AMOUNT_REG, AMOUNT_MAX, AMOUNT_INUPUT } from '@/config';

interface ValidateParams {
  required: boolean; // 是否必填
  requiredMsg?: string; // 必填提醒文案
}

interface FormatParams {
  max: number; // 金额上限
}

/*
 * validate amount value
 */
export const validateAmount = (value: string, params?: ValidateParams) => {
  if (value === null || value === undefined) {
    if (params && params.required) {
      return Promise.reject(
        new Error(params.requiredMsg || intl.get('bill_pre_settle_input_amount')),
      );
    }
    return Promise.resolve();
  }

  if (!AMOUNT_REG.test(value)) {
    return Promise.reject(new Error(intl.get('app_input_correct_format')));
  }

  if (+value < 0 || +value > AMOUNT_MAX) {
    return Promise.reject(new Error(intl.get('app_input_range_over_limit')));
  }

  return Promise.resolve();
};

/*
 * format amount value
 */
export const formatAmount = (value: string, params?: FormatParams) => {
  if (value === '') return value;

  if (+value === 0) return +value;

  // 输入的字符有问题或者超过金额上限
  if (!AMOUNT_INUPUT.test(value) || +value > AMOUNT_MAX) return value;

  // 校验是否超过最大值，同时判定最大值是否为小数
  if (params && params.max !== null && params.max !== undefined && +value > params.max) {
    const tmpMax = params.max.toString();
    return tmpMax.indexOf('.') > -1 ? params.max.toFixed(2) : `${params.max}.00`;
  }

  // 小数点
  const decimalIndex = value.indexOf('.');
  if (decimalIndex > -1) {
    // 小数点后超过2位
    if (value.substring(decimalIndex + 1).length > 2) {
      return value;
    }

    return (+value).toFixed(2);
  }

  return `${+value}.00`;
};
